export default "assets/images/line-top-manifest-198918ef.svg";